'use strict';

var sdk = require('@module-federation/sdk');
const FEDERATION_SUPPORTED_TYPES = ['script'];
Object.defineProperty(exports, "ENCODE_NAME_PREFIX", {
  enumerable: true,
  get: function () {
    return sdk.ENCODE_NAME_PREFIX;
  }
});
exports.FEDERATION_SUPPORTED_TYPES = FEDERATION_SUPPORTED_TYPES;